import { InstallationReferenceSelectionOverlayViewModel } from "../InstallationReferenceSelectionOverlayView"
import { InstallationReferenceSelectionOverlayModel } from "./useInstallationReferenceSelectionOverlayModel"

export function useInstallationReferenceSelectionOverlayViewModel(
  props: InstallationReferenceSelectionOverlayModel
): InstallationReferenceSelectionOverlayViewModel {
  return props
}
